import client from "../Client/HttpClient";
import {IStudentsModel} from "@/interfaces/modules";
const ApiPath = "Students";

export default {
    GetStudents:() : Promise <IStudentsModel[]> => client.get(`${ApiPath}`),
    GetStudentsbyId: (data: any): Promise <IStudentsModel> => client.get(`${ApiPath}/${data.Id}`), 
    PostStudents: (data: any): Promise<IStudentsModel> => client.post(`${ApiPath}`, data),
    GetReportPreEnrollment: (data: any): Promise<any> => client.get(`${ApiPath}/GetReportPreEnrollment/${data.Id}`)
  };